import { useEffect, useState } from 'react';
import { Image, ImageProps, ImageURISource, StyleSheet } from 'react-native';

interface Props extends ImageProps {
  source: ImageURISource;
}

const ChatTextItemImage = (props: Props) => {
  const { source, ...rest } = props;

  const [aspectRatio, setAspectRatio] = useState(1);

  useEffect(() => {
    if (source.uri) {
      Image.getSize(source.uri, (width, height) => {
        setAspectRatio(width / height);
      });
    }
  }, [source]);

  return (
    <Image
      style={[styles.image, { aspectRatio }]}
      source={source}
      resizeMode="contain"
      {...rest}
    />
  );
};

export default ChatTextItemImage;

const styles = StyleSheet.create({
  image: {
    borderRadius: 10,
    height: 200,
    maxWidth: '100%',
  },
});
